import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { TagsPage } from './_dashboard.catalog.tags'

export const Route = createFileRoute('/_dashboard/catalog/tags/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TagsItemPage,
})

function TagsItemPage() {
  const { item } = Route.useParams()
  return <TagsPage selectedId={item} />
}
